export { default } from './LoadingIcon';
